import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  @media (max-width: 1048px) {
    flex-direction: column-reverse;
  }
`;

export const Main = styled.main`
  width: 100%;
  margin: 0 auto;
  height: 100dvh;
  overflow: auto;
  padding: ${({ theme }) => theme.spacing[4]};

  scrollbar-color: #31383fff #1f252aff;
  scrollbar-width: thin;

  @media (max-width: 1048px) {
    height: calc(100dvh - var(--top-navigation-height) * 2);
    padding: ${({ theme }) => theme.spacing[3]};
  }

  > [role="alert"] {
    height: 100%;
    background-color: transparent;
  }
`;
